/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 * Translation constants for Expenses Analyzer
 *
 * @author Maxim Fedorov
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.1.0
 */
import { EExpensesAnalyzerField } from '@pages/PageExpensesAnalyzer/components/ExpensesAnalyzerTable/types/expensesAnalyzerTableTypes';

import { IPageExpensesAnalyzerTranslation } from '../../types';

export const initTranslationPageExpensesAnalyzer: IPageExpensesAnalyzerTranslation = {
    preliminaryData: '',
    preliminaryDataLink: '',

    table: {
        [EExpensesAnalyzerField.NAME]: '',
        [EExpensesAnalyzerField.MSISDN]: '',
        [EExpensesAnalyzerField.ACCOUNT]: '',
        [EExpensesAnalyzerField.CHARGES]: '',
        [EExpensesAnalyzerField.MONTH_CHARGE_SRLS]: '',
        [EExpensesAnalyzerField.MONTH_CHARGE_RTPL]: '',
        [EExpensesAnalyzerField.AMOUNT_TOTAL]: '',
        [EExpensesAnalyzerField.AMOUNT_LOCAL_MACRO]: '',
        [EExpensesAnalyzerField.AMOUNT_LOCAL]: '',
        [EExpensesAnalyzerField.AMOUNT_COUNTRY_ROAMING]: '',
        [EExpensesAnalyzerField.AMOUNT_ROAMING]: '',
    },

    chart: {
        category: {
            [EExpensesAnalyzerField.AMOUNT_LOCAL_MACRO]: '',
            [EExpensesAnalyzerField.AMOUNT_LOCAL]: '',
            [EExpensesAnalyzerField.AMOUNT_COUNTRY_ROAMING]: '',
            [EExpensesAnalyzerField.AMOUNT_ROAMING]: '',
            [EExpensesAnalyzerField.CHARGES]: '',
            [EExpensesAnalyzerField.MONTH_CHARGE_SRLS]: '',
            [EExpensesAnalyzerField.MONTH_CHARGE_RTPL]: '',
        },
    },
    controller: {
        chartCategory: '',
        chartDynamic: '',
    },
    dataIsCorrupted: '',
    errorText: '',
    linkToAccount: '',
    notData: '',
    selectAll: '',
    subText: '',
    tableFooter: {
        basketTitleAccounts: '',
        basketTitleSubscribers: '',
    },
    title: {
        dropFilters: '',
        expenses: '',
        exportTable: '',
        hideGraph: '',
        settingColumn: '',
        showGraph: '',
        tableSetting: {
            applyBtn: '',
            closeBtn: '',
            footnote: '',
            subTitle: '',
            title: '',
            titleBtn: '',
        },
    },
};
